import Cookies from 'js-cookie';

import { setTokens } from '~/domains/auth/utils/setTokens';
import { removeTokens } from '~/domains/auth/utils/removeTokens';
import log from '~/common/utils/log';
import { Routes } from '~/domains/common/constants/routes';
import { reportEvent } from '~/domains/analytics';

import { identityInstance } from './identity-instance';
import type { APIAuthRefreshTokenResponse } from './types';

let isRedirecting = false;

export const fetchRefreshToken = async (
  shouldRedirect = true,
  onErrorRedirectTo = Routes.signIn({
    brand: new URLSearchParams(window.location.search).get('brand') || undefined,
  })
): Promise<APIAuthRefreshTokenResponse['data']> => {
  try {
    const refreshToken = Cookies.get('refreshToken');
    const currentAccessToken = Cookies.get('accessToken');

    if (!refreshToken) {
      throw Error('No refresh token');
    }

    if (!currentAccessToken) {
      throw Error('No access token');
    }

    const response: APIAuthRefreshTokenResponse = await identityInstance.post(
      '/universal-auth/refresh',
      {
        refreshToken,
        accessToken: currentAccessToken,
      }
    );

    const tokenData = response.data;
    const { accessToken } = tokenData;
    setTokens({ accessToken })

    return tokenData;
  } catch (error) {
    reportEvent('User > Fetch RefreshToken Error', error);

    removeTokens();

    if (shouldRedirect && !isRedirecting) {
      isRedirecting = true;
      const fullUrl = `${window.location.origin}${onErrorRedirectTo}`;
      log(`Redirecting to ${fullUrl} because of a fetchRefreshToken error.`, error);
      window.location.href = fullUrl;
    }
    throw error;
  }
};
